module.exports = __webpack_public_path__ + "img/cloud_maintenance.ca3517e3.svg";